<template>
    <div class="monitor-bottom-warp">
        <monitorTitle nub="3" text="电器部件监测" />
        <div class="list">
            <div class="item" v-for="(i,k) in list" :key="k">
                <div class="label">{{i.name}}</div>
                <!-- <div class="value">{{i.value}}</div> -->
                <dv-digital-flop :config="i.config" style="width: 200px;height:40px;" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            list: {
                default: () => {
                    return []
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .monitor-bottom-warp {
        position: relative;

        .list {
            display: flex;
            width: 100%;
            height: 130px;
            background-image: url("/static/images/home/monitor/3.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;

            .item {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .label {
                    margin-bottom: 24px;
                    line-height: 1;
                    font-size: 14px;
                    letter-spacing: 1px;
                    color: #ffffff;
                }

                .value {
                    line-height: 1;
                    font-size: 28px;
                    font-style: italic;
                    letter-spacing: 1px;
                    color: #0fc4ff;
                }
            }
        }
    }
</style>
